import { IErrorScreen } from 'shared/models/IErrorScreen.interface';
import { INotificationFromStore } from 'shared/models/INotification.interface';
import { axiosGet, axiosPut } from 'utilities/axiosManagerFunctions';
import { eeEnvVariables } from 'utilities/constants';

export const axiosGetNotificationsFromStore = async (): Promise<
  INotificationFromStore[]
> => {
  try {
    const response = await axiosGet<INotificationFromStore[]>(`notifications`);
    return response?.data;
  } catch (err: any) {
    const errorMessage = err.message || err.toString();
    throw new Error(`API Error: "${errorMessage}"`);
  }
};

export const axiosMarkNotificationsFromStoreAsRead = async (
  notificationsIds: string[]
): Promise<any> => {
  try {
    const response = await axiosPut<any, any>(
      `notifications/update-notifications-read-status`,
      notificationsIds
    );
    return response?.data;
  } catch (err: any) {
    const errorMessage = err.message || err.toString();
    throw new Error(`API Error: "${errorMessage}"`);
  }
};

export const axiosGetSystemMaintenance =
  async (): Promise<IErrorScreen | null> => {
    try {
      const response = await axiosGet<IErrorScreen | null>(
        `GetSystemMaintenance?application=ic2b&systemArea=Employee`,
        {},
        eeEnvVariables.SM_API_URL
      );
      const data =
        response?.status >= 200 && response?.status <= 299
          ? response?.data
          : null;
      return data;
    } catch (err: any) {
      const errorMessage = err.message || err.toString();
      throw new Error(`API Error: "${errorMessage}"`);
    }
  };
